export const required = (value) => (value ? undefined : 'CAMPO OBRIGATÓRIO');

export const composeValidators =
    (...validators) =>
    (value) =>
        validators.reduce(
            (error, validator) => error || validator(value),
            undefined
        );

function validarEmail(email) {
    const regExp =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regExp.test(email) ? undefined : 'DIGITE UM E-MAIL VÁLIDO';
}

export const options = [
    {
        descricao: 'E-mail',
        valor: 'EMAIL',
        mask: '',
        placeholder: 'email@exemplo.com',
        validadores: [required, validarEmail],
    },
    {
        descricao: 'Telefone',
        valor: 'TELEFONE',
        mask: '(99) 99999-9999',
        placeholder: '(__) _____-____',
        validadores: [required],
    },
    {
        descricao: 'Whatsapp',
        valor: 'WHATSAPP',
        mask: '(99) 99999-9999',
        placeholder: '(__) _____-____',
        validadores: [required],
    },
];
